var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-col',[_vm._v("other")])
}
var staticRenderFns = []

export { render, staticRenderFns }